<div class="copo-datacenter-flex-box">
	<div class="copo-datacenter-layout-title" translate>datacenter.drag-and-drop-item-hint</div>
	<div class="copo-datacenter-layout-content">
		<div class="drag-container-wraper drag-container-right-border">
			<div class="drag-container">
				<h2 translate class="copo-datacenter-layout-content-header">eorder.fixed-columns</h2>
				<div
						cdkDropList
						#scrollableList="cdkDropList"
						[cdkDropListData]="columnAggregatorList.scrollableColumns"
						[cdkDropListConnectedTo]="[hidedList]"
						class="drag-list"
						(cdkDropListDropped)="drop($event)">
					<div class="drag-box drag-box-small-margin" *ngFor="let item of columnAggregatorList.scrollableColumns" cdkDrag>
						<mat-icon class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
						<span class="drag-box-added-label">{{item.header}}</span>
					</div>
				</div>
				<div class="hide-placeholder" *ngIf="columnAggregatorList.scrollableColumns.length === 0">
					<mat-icon svgIcon="md:drag_indicator"></mat-icon>
					<p translate>datacenter.drag-element-here-fixed</p>
				</div>
			</div>
		</div>
		<div class="add-sort-container center">
			<div class="drag-container-header">
				<mat-icon class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
				<copo-slide-button labelAfter="datacenter.sorting"
									labelBefore="datacenter.add-columns"
									(toggleChange)="onToggleChange()"
									[checked]="togglePosition">
				</copo-slide-button>
				<mat-icon class="chevron-icon-disactivated" svgIcon="sorting_icon"></mat-icon>
			</div>
			<div class="drag-container">
				<mat-form-field class="column-search" appearance="outline" subscriptSizing="dynamic">
					<mat-icon svgIcon="search" class="column-search-icon" matPrefix></mat-icon>
					<input
							[placeholder]="'search.placeholder' | translate"
							matInput
							type="text"
							spellcheck="false"
							autocomplete="off"
							[formControl]="searchTextControl"/>
					<button type="button" *ngIf="searchTextControl.value" matSuffix mat-icon-button
							(click)="searchTextControl.reset('');" tabindex="-1">
						<mat-icon svgIcon="md:close"></mat-icon>
					</button>
				</mat-form-field>
				<div
						cdkDropList
						#hidedList="cdkDropList"
						[cdkDropListData]="columnAggregatorList.allColumns"
						[cdkDropListConnectedTo]="[scrollableList]"
						class="drag-list drag-list-add"
						(cdkDropListDropped)="drop($event)">
					<div class="drag-box drag-box-bigger-margin" *ngFor="let item of columnAggregatorList.allColumns" cdkDrag>
						<mat-icon class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
						<span class="drag-box-added-label">{{item.header}}</span>

					</div>
					<div class="hide-placeholder" *ngIf="columnAggregatorList.allColumns.length === 0">
						<mat-icon svgIcon="md:drag_indicator"></mat-icon>
						<p translate>datacenter.all-columns-added-to-grid</p>
						<p translate>datacenter.drag-element-here-hide</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
